<template>
  <div class="mobile-content4">
    <div class="title-container">
      <div class="title-dec-left">
        <img src="@/assets/image/title-dec.png" alt="title decoration left" />
      </div>
      <div class="title-text">合作客户，好评不断</div>
      <div class="title-dec-right">
        <img src="@/assets/image/title-dec.png" alt="title decoration right" />
      </div>
    </div>

    <div class="card-show-container">
      <div
        class="card-wrapper"
        v-for="(card, index) in cardList"
        :key="index"
      >
        <div class="card">
          <div class="card-image">
            <img
              v-if="card.cardImage"
              :src="card.cardImage"
              :alt="card.cardAlt"
            />
          </div>
          <div class="card-content">
            {{ card.cardContent }}
          </div>
        </div>
        <div class="card-title">
          {{ card.cardTitle }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileContent4',
  data() {
    return {
      cardList: [
        {
          cardTitle: '民谣集烧烤酒馆',
          cardImage: 'https://ustatic.hudongmiao.com/miao/common/myj_176768996111537c982.webp',
          cardAlt: '民谣集烧烤酒馆使用松鼠互娱酒吧霸屏点歌系统',
          cardContent: '夜的星：“弹幕互动太逗了，匿名发‘求搭讪’居然有人回应，全场笑疯！”',
        },
        {
          cardTitle: '不二民谣音乐餐吧',
          cardImage: 'https://ustatic.hudongmiao.com/miao/common/bemy_1767689961115076a7e.webp',
          cardAlt: '不二民谣音乐餐吧使用松鼠互娱酒吧霸屏点歌系统',
          cardContent: '慵懒的猫：“玩摇骰子游戏，竟然幸运地赢了一瓶皇家礼炮，我真是太棒了。”',
        },
        {
          cardTitle: '塘遥火塘民谣酒吧',
          cardImage: 'https://ustatic.hudongmiao.com/miao/common/tyht_1767690031044d8cab1.webp',
          cardAlt: '塘遥火塘民谣酒吧使用松鼠互娱酒吧霸屏点歌系统',
          cardContent: '大摩：“点歌超方便，手机扫码秒上屏，不用扯着嗓子喊服务员！”',
        },
        {
          cardTitle: '梦田音乐LiveHouse',
          cardImage: 'https://ustatic.hudongmiao.com/miao/common/mtyy_1767690031044686fe4.webp',
          cardAlt: '梦田音乐LiveHouse使用松鼠互娱酒吧霸屏点歌系统',
          cardContent: '小C：“特效很炫酷，咱也当了一回榜一大哥，哈哈哈，感觉不错。”',
        },
        {
          cardTitle: '胡桃里乐队酒馆',
          cardImage: 'https://ustatic.hudongmiao.com/miao/common/htl_17676900842236ba211.webp',
          cardAlt: '胡桃里乐队酒馆使用松鼠互娱酒吧霸屏点歌系统',
          cardContent: '灰狼：“在祝福墙上看见多年未见的老朋友也来了，还有比这更惊奇的吗？”',
        },
        {
          cardTitle: 'TZ House音乐现场',
          cardImage: 'https://ustatic.hudongmiao.com/miao/common/tzhouse_176769008422452683a.webp',
          cardAlt: 'TZHouse音乐现场使用松鼠互娱酒吧霸屏点歌系统',
          cardContent: 'Sky：“原来在酒吧也能摇荭包雨啊，感谢老板让我中了最大红吧。”',
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.mobile-content4 {
  width: 100%;
  margin-top: 47px;

  .title-container {
    height: 38px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-end;
    gap: 12px;

    .title-dec-left {
      img {
        width: 61px;
        height: 21px;
        display: block;
        object-fit: contain;
      }
    }

    .title-text {
      font-weight: 700;
      font-size: 26px;
      color: #FFFFFF;
      align-self: flex-end;
      line-height: 1;
    }

    .title-dec-right {
      img {
        width: 61px;
        height: 21px;
        display: block;
        object-fit: contain;
        transform: scaleX(-1);
      }
    }
  }

  .card-show-container {
    margin-top: 32px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    gap: 30px;

    .card-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;

      .card-title {
        margin-top: 10px;
        font-weight: 500;
        font-size: 20px;
        color: #FFFFFF;
      }

      .card {
        width: 315px;
        height: 268px;
        border-radius: 12px;
        border: 2px solid #C95EFB;
        overflow: hidden;
        display: flex;
        flex-direction: column;

        .card-image {
          width: 100%;
          height: 174px;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            display: block;
            object-fit: cover;
          }
        }

        .card-content {
          width: 100%;
          height: 94px;
          padding: 8px 17px;
          font-weight: 500;
          font-size: 18px;
          color: #FFFFFF;
          line-height: 1.4;
          text-align: left;
          background: linear-gradient(270deg, #481FB9 1.43%, #9535BF 99.29%);
          box-sizing: border-box;
        }
      }
    }
  }
}
</style>
